import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import HomeIcon from '../SVG/HomeIcon';
import { SHOW_LEADERS, GOTO_PAGE } from '../REDUX/actions';
import { HIDE } from '../const';
import useGoHome from '../useGoHome';

const HomeButton = props => {
  const { common } = useSelector(state => state);
  const { singleApp } = common;
  const dispatch = useDispatch();
  const goHome = useGoHome();

  if (singleApp) {
    return null;
  }

  return (
    <div
      className="navigation-button home-button"
      onClick={() => {
        goHome();
        dispatch({ type: SHOW_LEADERS, op: HIDE });
        dispatch({ type: GOTO_PAGE, payload: { page: null } });
      }}>
      <HomeIcon width="36" color={props.color || 'white'} />
    </div>
  );
};

export default HomeButton;
